export class FilterDateString {
  static containsDate(itemValue, filterValue) {
    if (!itemValue) return false;
    const date = new Date(itemValue);
    if (isNaN(date)) return false;

    // Convert to MM/DD/YYYY
    const mm = String(date.getMonth() + 1);
    const dd = String(date.getDate());
    const yyyy = date.getFullYear();

    const formatted = `${mm}/${dd}/${yyyy}`;

    return formatted.includes(filterValue);
  }

  static filterData(data, filterDescriptor) {
    if (!filterDescriptor || !filterDescriptor.filters) return data;

    return data.filter(item => {
      return filterDescriptor.filters.every(f => {
        if (f.operator === 'contains' && item[f.field] instanceof Date) {
          return FilterDateString.containsDate(item[f.field], f.value);
        }
        // fallback to default contains behavior for strings
        if (f.operator === 'contains' && typeof item[f.field] === 'string') {
          return item[f.field]?.toLowerCase().includes(f.value.toLowerCase());
        }
        return true; // you can extend more operators if needed
      });
    });
  }
}
